<template>
    <div>
        <el-row :gutter="20">
            <div class="collage-prod">
                <div class="btns">
                    <el-col :span="8">
                        <el-input v-model="proName" placeholder="众筹商品名称" :disabled="true"></el-input>
                    </el-col>
                    <el-col :span="2" :offset="12">
                        <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary" class="header-btn" @click="add()">新建</el-button>
                    </el-col>
                </div>
                <el-table :data="selectList" v-loading="listLoading" v-show="isShow" border fit
                          highlight-current-row stripe
                          style="width: 100%;">
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column align="center" v-show="false"  label="商品配置id">
                        <template slot-scope="scope">
                            <span>{{scope.row.bacthId}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="优惠券名称" v-show="false">
                        <template slot-scope="scope">
                            <span>{{scope.row.batchName}}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="操作">
                        <template slot-scope="scope">
                            <el-button type="danger" size="mini" @click="deleteCoupon(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog title="所有优惠券"  :visible.sync="designTable"  center class="main-title">
                    <el-row>
                        <el-input v-model="proId" v-show="false" placeholder="众筹商品id"></el-input>
                    </el-row>
                    <el-row>
                        <el-checkbox-group v-model="checkedBaseData" @change="checkBaseDataItem">
                            <el-checkbox v-for="item in baseDataList" :label="item" :key="item.bacthId"
                                         class="check-item">
                                {{item.batchName}}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-row>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="designTable=false">取 消</el-button>
                        <el-button type="primary" @click="sureAct">确 定</el-button>
                    </span>
                </el-dialog>
            </div>
        </el-row>
    </div>
</template>

<script>
    import {
        getCrowdProductCouponList,
        saveCrowdCouponConfig,
        deleteCrowdCoupon
    } from  '@/api/api'

    export default ({
        data() {
            return {
                list: [],
                activeNo: '',//活动号
                proId:'',//产品id
                proName:'众筹商品名称',
                checkedBaseData: [],    // 已选中的
                selectData:[],//选中的
                saveDataList: [],
                isShow:true,
                designTable:false,
                selectList:[],//列表已选择的
                baseDataList:[],
                designTable: true,  // 是否显示商品弹窗
                listLoading: false,  // 查询table的loading
            }
        },
        created() {
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.activeNo = this.$route.query.activeNo;
            this.proId = this.$route.query.proId;
            this.proName = this.$route.query.proName;
            this.designTable = false;
            this.getCouponList();
        },
        methods: {
            // 选中/不选中基础数据子项事件
            checkBaseDataItem() {
            },
            add(){
                this.designTable=true;
            },
            // 获取所有商品列表和 获取已选中的商品列表
            getCouponList() {
                this.listLoading = true;
                getCrowdProductCouponList({activeNo: this.activeNo,proId: this.proId}).then((res) => {
                    this.listLoading = false;
                    this.selectList=[];
                    this.baseDataList=[];
                    if (res.data.status == 200) {
                        this.baseDataList = res.data.value.allCouponList;
                        if(res.data.value.selectCouponList!=null){
                            this.selectList = res.data.value.selectCouponList;
                            this.baseDataList=res.data.value.allCouponList;
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.back()
            },
            productChange(){
                //全品类
                setCollageConfigProduct({
                    collageId: this.collageId,
                    activeNo: this.activeNo,
                    productType: (this.selectAll ? 1 : 2)
                }).then(res => {
                    this.listLoading = false;
                    if (res.data.status == 200) {
                        this.designTable = false;
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        if (this.selectAll) {
                            this.checkedBaseData = [];
                        } else {
                            if (this.checkedBaseData.length == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '未配置拼单商品',
                                    type: 'error'
                                });
                            }
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },

            // 点击确定 保存已选商品
            sureAct() {
                if (this.checkedBaseData.length >= 2) {
                    this.$message({
                        showClose: true,
                        message: '不支持众筹多个优惠券',
                        type: 'error'
                    });
                    return;
                }
                if (this.checkedBaseData.length == 0) {
                    this.$message({
                        showClose: true,
                        message: '请选择优惠券',
                        type: 'error'
                    });
                } else {
                    for (var j = 0, len = this.checkedBaseData.length; j < len; j++) {
                        this.checkedBaseData[j].activeNo = this.activeNo;
                        this.checkedBaseData[j].proId = this.proId;
                    }
                    for (var j = 0; j <  this.checkedBaseData.length; j++) {
                        for (var i = 0; i < this.selectList.length; i++) {
                            if(this.selectData[j]){
                                if(this.baseDataList[j].batchName===this.selectData[i].batchName){
                                    this.$message({
                                        showClose: true,
                                        message: this.selectData[i].batchName+'已存在',
                                        type: 'error'
                                    });
                                    return;
                                }
                            }
                        }
                    }
                    var params = {
                        'list' : encodeURIComponent(JSON.stringify(this.checkedBaseData)),
                        'activeNo' : this.activeNo,
                        'proId' : this.proId
                    }
                    saveCrowdCouponConfig(params).then(res => {
                        if (res.data.status == 200) {
                            this.designTable = false;
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.checkedBaseData=[];
                            this.getCouponList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            },
            deleteCoupon(row){
                this.$confirm('删除优惠券, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //删除商品
                    this.listLoading = true;
                    deleteCrowdCoupon({proId: this.proId}).then(res => {
                        this.listLoading = false;
                        if (res.data.status == 200) {
                            this.designTable = false;
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.getCouponList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                });
            }
        }
    })
</script>

<style lang="scss">
    .collage-prod {
        .btns {
            margin: 10px;
        }
        .el-checkbox-group {
            max-height: 300px;
            overflow: scroll;
            label {
                min-width: 190px;
                margin-bottom: 20px;
                margin-left: 0;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/crowd/productCoupon.vue